import React from "react"

const MorningStarRight = ({
  colors = [
    "#949494",
    "#BDBDBC",
    "#D9D9D8",
    "#B78E5F",
    "#856745",
    "#523F2B",
    "#525252",
    "#C2C2C1",
    "#787879",
    "#SVGID_",
    "#FFFFFF",
    "#F6F6F6",
    "#E4E5E6",
    "#C8CACC",
    "#A2A4A7",
    "#757779",
    "#2D2D2E",
    "#000000"
  ]
}) => {
  return (
    <g id="MorningStarRight">
      <polygon
        opacity="0.38"
        points="27.6,74.4 26.1,73.8 22.8,76.5 22.9,78.4 28.4,75.5"
      />
      <polygon
        fill={colors[0]}
        points="16.7,67.9 16.7,70.2 15.7,69 15.7,66.5"
      />
      <polygon
        fill={colors[1]}
        points="16.7,67.9 16.7,68.4 15.7,67.3 15.7,66.5"
      />
      <polygon
        fill={colors[0]}
        points="15.6,71.1 16.7,70.2 16.6,72.5 15.6,73.4"
      />
      <polygon
        fill={colors[1]}
        points="16.6,70.9 15.6,71.7 15.6,71.1 16.7,70.2"
      />
      <polygon
        fill={colors[0]}
        points="16.6,74.3 16.6,76.6 15.6,75.4 15.6,72.9"
      />
      <polygon
        fill={colors[1]}
        points="16.6,74.3 16.6,74.8 15.6,73.7 15.6,72.9"
      />
      <polygon
        fill={colors[0]}
        points="15.6,77.5 16.6,76.6 16.6,78.9 15.5,79.8"
      />
      <polygon
        fill={colors[1]}
        points="16.6,77.3 15.6,78 15.6,77.5 16.6,76.6"
      />
      <polygon
        fill={colors[0]}
        points="16.5,81.1 16.5,83.4 15.5,82.2 15.5,79.8"
      />
      <polygon
        fill={colors[1]}
        points="16.5,81.1 16.5,81.7 15.5,80.5 15.5,79.8"
      />
      <polygon
        fill={colors[0]}
        points="15.5,84.3 16.5,83.4 16.5,85.8 15.5,86.6"
      />
      <polygon
        fill={colors[1]}
        points="16.5,84.1 15.5,84.9 15.5,84.3 16.5,83.4"
      />
      <polygon
        fill={colors[0]}
        points="15.7,64.2 16.7,63.3 16.7,65.7 15.7,66.5"
      />
      <polygon
        fill={colors[1]}
        points="16.7,64 15.7,64.8 15.7,64.2 16.7,63.3"
      />
      <g fill={colors[2]}>
        <polygon points="17.7,87.4 17.7,86.8 17.1,87.1" />
        <polygon points="14.2,92.9 14.2,93.5 14.8,93.2" />
        <polygon points="13.2,88.4 12.6,88.4 12.9,89" />
        <polygon points="18.7,91.9 19.3,91.9 19,91.3" />
        <polygon points="12.7,91 12.3,91.5 12.9,91.6" />
        <polygon points="19,89.3 19.4,88.8 18.8,88.7" />
        <polygon points="16.6,93.5 17,93.9 17.1,93.3" />
        <polygon points="15.1,87.1 14.7,86.7 14.5,87.3" />
      </g>
      <g fill={colors[2]}>
        <polygon points="16.5,86.9 16.3,86.4 15.9,86.9" />
        <polygon points="15.4,93.4 15.6,93.9 16,93.4" />
        <polygon points="12.7,89.6 12.2,89.8 12.7,90.2" />
        <polygon points="19.2,90.7 19.7,90.5 19.2,90.1" />
        <polygon points="13.2,92.2 13,92.7 13.7,92.6" />
        <polygon points="18.5,88.2 18.7,87.7 18.1,87.8" />
        <polygon points="17.7,93 18.3,93.3 18.2,92.7" />
        <polygon points="14.1,87.6 13.5,87.4 13.6,88" />
      </g>
      <g fill={colors[2]}>
        <polygon points="15.9,87.6 15.6,87.2 15.4,87.7" />
        <polygon points="16.1,92.6 16.4,93 16.6,92.5" />
        <polygon points="13.5,90.2 13.1,90.5 13.6,90.7" />
        <polygon points="18.5,90 18.9,89.7 18.4,89.5" />
        <polygon points="14.4,92.1 14.3,92.5 14.7,92.3" />
        <polygon points="17.5,88.2 17.6,87.8 17.2,88" />
        <polygon points="17.8,91.9 18.3,92 18.1,91.6" />
        <polygon points="14.2,88.6 13.7,88.5 13.9,88.9" />
      </g>
      <path
        fill={colors[3]}
        d="M33.7,86L19.8,65.1c0,0-1.3-1.3-2.3-0.5c-1.1,0.8-0.5,2.6-0.5,2.6l14.8,20.4c0,0,0.9,0.2,1.4-0.2 C33.7,86.9,33.7,86,33.7,86z"
      />
      <path
        fill={colors[4]}
        d="M16.9,67.1l14.8,20.4c0,0,0.5,0.1,1,0l0,0c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.2,0-0.2,0.1-0.1l0,0 c-0.2-0.2-0.3-0.4-0.4-0.6c0,0,0,0-0.1,0c-0.1-0.1-0.7-0.6-0.6-0.6c-0.2-0.2-0.5-0.6-0.2-0.4c0.1,0.1,0.7,0.6,0.6,0.6 c0.1,0.1,0.2,0.2,0.3,0.3c0-0.1,0-0.3,0-0.4c0,0,0,0,0.1,0c-0.1-0.1-0.1-0.2-0.1-0.2c0.1-0.1,0.3,0.1,0.4,0.2 c-0.2-0.2-0.4-0.5-0.6-0.7c0,0.1,0,0.3,0,0.4s-0.6-0.2-0.8-0.4c-0.2-0.1-0.3-0.2-0.4-0.4c-0.1-0.1-0.1-0.2,0.1-0.1l0.1,0.1 c0,0,0.1,0.1,0.2,0.1c0-0.1,0-0.2,0-0.3c0,0.1-0.4-0.1-0.4-0.1c-0.2-0.1-0.4-0.3-0.4-0.4c-0.1-0.4-0.2-0.9-0.3-1.3 c0,0,0-0.1,0.1,0c-0.1-0.1-0.3-0.2-0.3-0.3l-0.2-0.5l0,0l-0.2-0.5c0.1,0.3,0.1,0.7,0.2,1c0.2,0.2,0.6,0.6,0.3,0.5 c-0.1,0-0.2-0.1-0.3-0.2c0,0.1-0.1,0-0.1,0c0.2,0.1,0.6,0.6,0.5,0.6l0.1,0.1c0.2,0.3,0.3,0.6,0.6,0.9c0.1,0.1,0.2,0.2,0,0.3 c-0.1,0-0.5-0.3-0.6-0.4c-0.3-0.4-0.6-0.7-0.8-1.2c-0.1-0.3,0.1-0.2,0.2-0.2c-0.1-0.1-0.2-0.3-0.2-0.3h-0.1 c-0.1-0.1-0.4-0.3-0.4-0.4c-0.1-0.4-0.1-0.8-0.2-1.2l0,0c0-0.1-0.1-0.2,0-0.2v-0.1c-0.1-0.1-0.2-0.2-0.3-0.3 c-0.1-0.5-0.3-1-0.5-1.5c-0.1-0.1-0.1-0.1-0.1-0.2c0-0.2-0.1-0.3-0.2-0.5c-0.1-0.1-0.2-0.1-0.3-0.2c0.1,0.1,0.2,0.2,0.2,0.3 c-0.1,0.2-0.1,0.5-0.1,0.7l0,0c0.1,0,0.2,0,0.2,0.1c0.2,0.1,0.4,0.3,0.5,0.5c0.1,0.1,0.1,0.2,0.1,0.4c0,0.1-0.9-0.3-0.8-0.6v-0.2 v-0.1c-0.2,0-0.8-0.3-0.8-0.6c0-0.2,0-0.5,0.1-0.7c-0.1-0.1-0.2-0.2-0.3-0.3c0,0,0-0.1-0.1-0.1l-0.1-0.1c-0.2-0.1-0.3-0.2-0.5-0.3 c0,0-0.1-0.1-0.2-0.1c0,0.1,0,0.1-0.1,0c-0.1,0-0.3-0.2-0.4-0.4c-0.1-0.1-0.3-0.2-0.3-0.4c0-0.1,0-0.2-0.1-0.3 c-0.1-0.1,0-0.1,0.1-0.1l0,0l-0.4-0.2c-0.2-0.1-0.5-0.2-0.6-0.4c-0.1-0.1-0.1-0.2,0.1-0.1l0.4,0.2c0,0,0.1,0,0.1,0.1 c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0.1c0.1,0,0.1,0.1,0.1,0.1c0.2,0.2,0.5,0.5,0.2,0.4c0.2,0.1,0.3,0.2,0.5,0.4c0,0.1,0.1,0.1,0.1,0.2 c0.2,0.1,0.3,0.2,0.5,0.3c-0.1-0.2-0.2-0.4-0.2-0.6s0.4,0.1,0.4,0.1c0.2,0.1,0.4,0.3,0.4,0.4c0,0,0,0,0,0.1c0.1,0,0.3,0.2,0.4,0.2 c0.2,0.2,0.4,0.3,0.6,0.5c0,0,0.1,0.1,0.2,0.2c0-0.1-0.1-0.1-0.1-0.2l0,0c-0.3-0.3-0.7-0.6-0.9-0.9c-0.2-0.2-0.4-0.5-0.6-0.8 c0,0-0.1,0-0.2-0.1c-0.1-0.1-0.2-0.1-0.3-0.2c0,0.1,0.1,0.2,0.1,0.2c0.1,0.2-0.2,0.1-0.3,0c-0.2-0.1-0.4-0.3-0.5-0.5 c-0.2-0.4-0.4-0.8-0.6-1.1l0,0c-0.3-0.1-0.5-0.3-0.7-0.6c-0.1-0.2,0-0.2,0.1-0.1c0.1,0,0.2,0.1,0.2,0.1c-0.2-0.3-0.3-0.5-0.5-0.8 v-0.1c-0.1-0.1-0.2-0.2-0.2-0.2c-0.1,0-0.1-0.1-0.2-0.2c-0.2-0.1-0.4-0.2-0.5-0.4c0,0.1,0,0.2-0.1,0.1h-0.1 c-0.2-0.1-0.5-0.2-0.6-0.4c-0.1-0.1-0.1-0.2,0.1-0.1h0.1c0.1,0,0.2,0.1,0.2,0.1v-0.1h0.1c-0.2-0.3-0.4-0.6-0.6-0.9 c-0.4-0.2-0.8-0.5-1.1-0.9c0,0,0,0-0.1,0c-0.1-0.1-0.4-0.3-0.4-0.4c-0.1-0.4-0.2-0.8-0.4-1.1c0-0.1,0-0.1,0-0.1 c-0.1-0.1-0.3-0.2-0.3-0.3l-0.1-0.1c0.1,0.2,0.2,0.3,0,0.2c0,0-0.1-0.1-0.2-0.2l0,0c-0.1,0-0.2-0.1-0.3-0.3 c0.1,0.1,0.1,0.1-0.1,0.1l0,0c0,0,0,0.1,0.1,0.1c0.2,0.1,0.4,0.4,0.5,0.5c0.2,0.2,0.5,0.5,0.2,0.4c-0.1,0-0.3-0.2-0.4-0.4 c-0.1,0-0.2-0.1-0.2-0.1c-0.2-0.1-0.4-0.3-0.5-0.4S18,67.4,18,67.3c0-0.1,0.1-0.1,0.1,0c0,0,0-0.1-0.1-0.1c-0.1-0.1-0.2-0.3,0-0.2 c-0.1-0.1-0.1-0.2,0.1-0.1c0,0,0,0,0.1,0.1c-0.2-0.2-0.5-0.6-0.2-0.4c0.1,0.1,0.5,0.4,0.6,0.6l0,0c0,0,0.1,0.1,0.2,0.2l0,0 c0,0,0.1,0.1,0.2,0.2l0,0c-0.1-0.1-0.1-0.2,0.1-0.1l0.2,0.1l0.1,0.1l0,0c-0.1-0.1-0.3-0.2-0.4-0.3h-0.1c-0.2-0.1-0.5-0.2-0.6-0.4 c-0.1-0.1-0.1-0.2,0.1-0.1l0.1,0.1c0.1,0,0.1,0.1,0.2,0.1c-0.2-0.4-0.4-0.9-0.6-1.3c-0.2-0.1-0.4-0.3-0.4-0.4s0.1-0.1,0.1-0.1 c-0.1-0.2-0.2-0.4-0.3-0.5c-0.1,0-0.3,0.1-0.4,0.2C16.4,65.3,16.9,67.1,16.9,67.1z M28.2,81.3c0.2,0.1,0.8,0.8,0.4,0.6 C28.5,81.8,27.8,81.1,28.2,81.3z M27.6,80.5c0-0.2,0.3,0.1,0.4,0.1c0.1,0.1,0.3,0.2,0.4,0.3c0.1,0.1,0.1,0.2,0.1,0.2 c0,0.2-0.1,0.1-0.3,0S27.7,80.8,27.6,80.5z M27.5,80c0.2,0.1,0.8,0.8,0.4,0.6C27.8,80.5,27.1,79.8,27.5,80z M27.1,79.2 c0.2,0.1,0.8,0.8,0.4,0.6C27.3,79.7,26.7,79.1,27.1,79.2z M25.2,76.7c0.2,0.1,0.4,0.3,0.5,0.5c0.2,0.3,0.4,0.5,0.6,0.8 c0.1,0.2,0,0.2-0.1,0.1c-0.2,0-0.4-0.3-0.6-0.4c-0.3-0.3-0.5-0.6-0.7-0.9C24.8,76.6,25.1,76.7,25.2,76.7z M21.8,71.2 c-0.1,0-0.3-0.3-0.5-0.5c0,0,0,0-0.1,0c-0.2-0.1-0.8-0.8-0.4-0.6c0.1,0,0.3,0.3,0.5,0.5c0,0,0,0,0.1,0 C21.6,70.7,22.2,71.4,21.8,71.2z M23.4,73.2c-0.1,0-0.2-0.2-0.4-0.3c0,0,0,0-0.1,0c-0.2-0.1-0.8-0.8-0.4-0.6 c0.1,0,0.2,0.2,0.4,0.3c0,0,0,0,0.1,0C23.2,72.7,23.8,73.4,23.4,73.2z M22.7,73.3c0.1,0,0.3,0.2,0.4,0.3h0.1 c0.2,0,0.4,0.3,0.6,0.4c0.1,0.2,0.2,0.3,0.4,0.4c0.1,0.1,0.3,0.3,0.2,0.3c-0.1,0.1-0.5-0.2-0.5-0.3c-0.2-0.2-0.3-0.3-0.5-0.5 c0,0-0.1,0-0.2,0c-0.2,0-0.4-0.3-0.6-0.4l-0.1-0.1C22.5,73.3,22.6,73.3,22.7,73.3z M22.2,72.5c0.2,0.1,0.8,0.8,0.4,0.6 C22.5,73,21.8,72.3,22.2,72.5z M22.1,72.1c0.2,0.1,0.8,0.8,0.4,0.6C22.4,72.6,21.7,71.9,22.1,72.1z M21.3,71.3 c0.2,0.1,0.8,0.8,0.4,0.6C21.6,71.8,21,71.1,21.3,71.3z M20.8,70.3c0.2,0.1,0.8,0.8,0.4,0.6C21,70.8,20.4,70.2,20.8,70.3z M20.5,69.8c-0.2-0.1-0.8-0.7-0.5-0.6c-0.2-0.1-0.8-0.8-0.4-0.6c0.2,0.1,0.8,0.7,0.5,0.6C20.2,69.3,20.9,70,20.5,69.8z M19.8,69.9 c0.2,0.1,0.8,0.8,0.4,0.6C20.1,70.4,19.4,69.7,19.8,69.9z M19.4,68.9c0.2,0.1,0.8,0.8,0.4,0.6C19.7,69.3,19,68.7,19.4,68.9z M17.9,65.3c-0.2-0.1-0.8-0.8-0.4-0.6C17.7,64.8,18.3,65.5,17.9,65.3z M17.3,65.1C17.3,65.1,17.4,65.1,17.3,65.1 C17.4,65.1,17.4,65.1,17.3,65.1l0.2,0.1c0.2,0.1,0.5,0.2,0.6,0.4c0,0.1,0.1,0.1,0,0.2c0.1,0.1,0.2,0.2,0.2,0.2 c0.2,0.2,0.3,0.3,0.1,0.2c-0.1-0.1-0.5-0.4-0.5-0.5l0,0c0,0,0,0-0.1,0c-0.2-0.1-0.4-0.2-0.5-0.4C17.3,65.2,17.2,65.1,17.3,65.1 C17.2,65,17.2,65,17.3,65.1z"
      />
      <path
        fill={colors[5]}
        d="M20.2,65.6c0,0,0,0.9-1.1,1.7c-0.9,0.7-1.6,0.6-1.6,0.6L17,67.2l3.1-1.9L20.2,65.6z"
      />
      <path
        fill={colors[0]}
        d="M19.9,65l-1.3-1.7c0,0-1.6-0.3-2,0c-0.4,0.4-0.8,2.1-0.8,2.1l1.2,1.7c0,0,0.2,1,1.9,0S19.9,65,19.9,65z"
      />
      <path
        fill={colors[6]}
        d="M18.4,67.3l-1.8-2.4l0.1-1c0,0-0.8,0.5-0.8,1.2s1.3,2.5,1.3,2.5S17.8,67.5,18.4,67.3z"
      />
      <path
        fill={colors[7]}
        d="M19.8,66l-1.5-2.3c0,0-1.2-0.5-1.5-0.2c0.6,0.2,2.6,3.1,2.6,3.1L19.8,66z"
      />
      <circle fill={colors[8]} cx="15.9" cy="90.1" r="3.5" />
      <circle fill="url(#SVGID_16_)" cx="15.9" cy="90.1" r="3.5" />
      <radialGradient
        id="SVGID_16_"
        cx="-365.69"
        cy="60.78"
        r="3.528"
        gradientTransform="matrix(-.9999 -.01072 .01072 -.9999 -350.383 146.984)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#fff" />
        <stop offset="0.698" stopColor="#fff" stopOpacity="0.1" />
        <stop offset="0.724" stopColor="#f6f6f6" stopOpacity="0.1" />
        <stop offset="0.762" stopColor="#e4e5e6" stopOpacity="0.1" />
        <stop offset="0.809" stopColor="#c8cacc" stopOpacity="0.1" />
        <stop offset="0.862" stopColor="#a2a4a7" stopOpacity="0.1" />
        <stop offset="0.921" stopColor={colors[15]} stopOpacity="0.1" />
        <stop offset="0.983" stopColor="#2d2d2e" stopOpacity="0.1" />
        <stop offset="0.995" stopOpacity="0.1" />
      </radialGradient>
    </g>
  )
}

export default MorningStarRight
